<template>
  <div>
     <v-row justify-md="center">
      <v-col sm="10" md="7">
        <h1>Link your twitch account</h1>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      
      <v-col  sm="10" md="7">
        <p>Link your Twitch and Apex accounts to receive rewards during special events</p>

        <v-btn  @click="linkTwitch()" v-if="!isLinked" :loading="loading"><v-icon color="#6441a5">mdi-twitch</v-icon> Link</v-btn>
        <v-alert v-if="isLinked">Already linked</v-alert> 
      </v-col>
    </v-row>
     <v-dialog v-model="twitchFailureDialog" width="600" :fullscreen="$vuetify.breakpoint.mobile">
      <v-card>
        <v-card-title class="headline">Failed to link twitch account</v-card-title>

        <v-card-text>{{failureText}}</v-card-text>

        <v-card-actions>
          <v-btn text @click="twitchFailureDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="allowRetry"  @click="linkTwitch()" :loading="loading"><v-icon color="#6441a5">mdi-twitch</v-icon> Try again</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import Vue from 'vue'
import {achost} from '@/store/constants';
import {ErrAccountAlreadyHasThisPlatform, ErrPlatformIdentifierAlreadyRegisteredToAnotherEmail} from '@/plugins/apexErrors'
export default {
  name: "TwitchConnect",
  data() {
    return {
      isLinked: false,
      loading: true,
      twitchFailureDialog: false,
      allowRetry: true,
      failureText: "Try again",
    }
  },
  created() {
    this.loading = true;

    // check if we have a location hash. 
    const search = window.location.search.substring(1).split("&").reduce((res, val) => {
      let parts = val.split('=');
      if (parts[0]) {
        res[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
      }
      return res;
    }, {});


    if (search.code && search.state) {
      this.createTwitchUser(search.code, search.state).then(() => {
        this.$router.replace("/settings")
      }).catch((err) => {
        this.$router.replace("/twitch/link");
        // show failed to link...
        if (err.response && err.response.data) {
          if (err.response.data.code == ErrAccountAlreadyHasThisPlatform) {
            this.allowRetry = false;
            this.failureText = "Your Apex Connect account has earlier been linked to another twitch account. You can only link one twitch account with your Apex Connect Account. If you believe this to be a mistake contact Apex Connect Support.";
          } else if ( err.response.data.code == ErrPlatformIdentifierAlreadyRegisteredToAnotherEmail) {
            this.allowRetry = false;
            this.failureText = "Your twitch account has already been linked to another Apex Connect account. You can only link one Apex Connect account to your twitch account. If you believe this to be a mistake contact Apex Connect Support.";
          }
        } else {
            this.allowRetry = true;
            this.failureText = "Uknown error. Try Again";
        }
        this.loading = false;
        this.twitchFailureDialog = true;

      });

    } else {
      this.$store.dispatch("account/getHasTwitch").then((status) => {
        this.loading = false;
        this.isLinked = status;
        if (status) {
          this.$router.replace("/settings")
        }
      })
    }

  },
  methods: {
    linkTwitch() {
      //const game = $route.params.game;
      this.loading = true;
      Vue.axios.get(`${achost}/portal/api/twitch/authorizeUrl`).then((resp) => {
        window.location.href = resp.data.status;  
      })
      
      //const url = `https://id.twitch.tv/oauth2/authorize?client_id=${twitch_client_id}&redirect_uri=${twitch_redirect_uri}&response_type=code&scope=openid`
      
    },
    createTwitchUser(code, state) {
      return Vue.axios.get(`${achost}/portal/api/twitch/link?code=${code}&state=${state}`);
    }
  }
}
</script>